import React from 'react';
import { FormikValues } from 'formik';
import styled from 'styled-components';
import dayjs from 'dayjs';

import { ButtonElem } from '../../common/button';
import { AlertActionElem } from '../../common/alert-action';
import { LoaderElem } from '../../common/loader';
import { FormElem } from '../../common/form';
import { FieldTextElem } from '../../common/field-text';
import { FieldTextAreaElem } from '../../common/field-text-area';
import { SelectElem } from '../../common/select';
import { Spacing } from '../../theme';
import { FORM_VALUE_ENUM } from './constant';
import { LANGUAGE_LIST } from '../../lib/lang/value';
import {
  POPUP_ITEM_DATA_INTER,
  POPUP_STATUS_LIST,
} from '../admin-popup-list/constant';
import { FieldDatePickerElem } from '../../common/field-date-picker';
import { ModalPopupTestView } from '../../data/popup/frame/modal-test-view';

export const Component: React.FC<{
  isSubmitDisabled: Function;
  isError?: boolean;
  isSuccess?: boolean;
  errorMessage?: string;
  handleUpdate: Function;
  isLoading?: boolean;
  formik: FormikValues;
  getFieldValue: Function;
  getFieldError: Function;
  isFieldError: Function;
  setFieldValue: Function;
  setValue: Function;
  data: POPUP_ITEM_DATA_INTER;
}> = ({
  isSubmitDisabled,
  isError,
  errorMessage,
  isSuccess,
  handleUpdate,
  isLoading,
  formik,
  getFieldError,
  isFieldError,
  setFieldValue,
  getFieldValue,
  setValue,
  data,
}) => {
  const [showAlert, setShowAlert] = React.useState(false);
  const [isTestModalOpen, setTestModalOpen] = React.useState(false);

  const onChange = (date: dayjs.Dayjs, _dateString: string | string[]) => {
    const dateValue = date?.format ? date.format('YYYY-MM-DD') : '';

    const today = dayjs().startOf('day');
    if (date.isBefore(today)) {
      setShowAlert(true);
      return;
    }
    setShowAlert(false);
    formik.setFieldValue(FORM_VALUE_ENUM.DEADLINE, dateValue);
  };

  const openTestPreview = () => {
    setTestModalOpen(true);
  };

  const POPUP_MODAL_TEST = {
    body: getFieldValue(FORM_VALUE_ENUM.BODY),
    linkUrl: getFieldValue(FORM_VALUE_ENUM.LINK_URL),
    imgUrl: getFieldValue(FORM_VALUE_ENUM.IMG_URL),
  };

  return (
    <FormElem onSubmit={() => {}}>
      <Container>
        <ExpandContainer>
          <SaveContainer>
            <SelectElem
              placeholder="POPUP.CREATE.STATUS"
              options={POPUP_STATUS_LIST}
              name={FORM_VALUE_ENUM.STATUS}
              onChange={setFieldValue}
              errorMessage={getFieldError(FORM_VALUE_ENUM.STATUS)}
              error={isFieldError(FORM_VALUE_ENUM.STATUS)}
              defaultValue={getFieldValue(FORM_VALUE_ENUM.STATUS)}
            />
            <ButtonElem
              onClick={handleUpdate}
              disabled={isSubmitDisabled()}
              type="submit"
              tid="POPUP.CREATE.SAVE_BUTTON"
            />
          </SaveContainer>

          <FieldTextAreaElem
            placeholder="POPUP.CREATE.BODY"
            name={FORM_VALUE_ENUM.BODY}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={getFieldValue(FORM_VALUE_ENUM.BODY)}
            errorMessage={getFieldError(FORM_VALUE_ENUM.BODY)}
            error={isFieldError(FORM_VALUE_ENUM.BODY)}
          />

          <FieldTextElem
            placeholder="POPUP.CREATE.IMG_URL"
            name={FORM_VALUE_ENUM.IMG_URL}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={getFieldValue(FORM_VALUE_ENUM.IMG_URL)}
            errorMessage={getFieldError(FORM_VALUE_ENUM.IMG_URL)}
            error={isFieldError(FORM_VALUE_ENUM.IMG_URL)}
          />
          <FieldTextElem
            placeholder="POPUP.CREATE.LINK_URL"
            name={FORM_VALUE_ENUM.LINK_URL}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={getFieldValue(FORM_VALUE_ENUM.LINK_URL)}
            errorMessage={getFieldError(FORM_VALUE_ENUM.LINK_URL)}
            error={isFieldError(FORM_VALUE_ENUM.LINK_URL)}
          />

          <DoubleContainer>
            <FieldDatePickerElem
              placeholder="POPUP.CREATE.DEADLINE"
              onChange={onChange}
              defaultValue={getFieldValue(FORM_VALUE_ENUM.DEADLINE)}
              disabledDate={(current) =>
                current && current.isBefore(dayjs(), 'day')
              }
            />
            <SelectElem
              dynamic
              placeholder="POPUP.CREATE.LANG"
              options={LANGUAGE_LIST}
              name={FORM_VALUE_ENUM.LANG}
              onChange={setFieldValue}
              errorMessage={getFieldError(FORM_VALUE_ENUM.LANG)}
              error={isFieldError(FORM_VALUE_ENUM.LANG)}
              defaultValue={getFieldValue(FORM_VALUE_ENUM.LANG)}
            />
          </DoubleContainer>

          <ButtonElem
            onClick={openTestPreview}
            type="submit"
            tid="POPUP.CREATE.TEST_VIEW"
          />
          {isTestModalOpen && (
            <ModalPopupTestView
              isOpen={isTestModalOpen}
              onClose={() => setTestModalOpen(false)}
              data={POPUP_MODAL_TEST}
            />
          )}
        </ExpandContainer>
      </Container>
      {isError && <AlertActionElem tid={`ERROR.${errorMessage}`} />}
      {isSuccess && <AlertActionElem type="success" tid="Success" />}
      {isLoading && <LoaderElem />}
    </FormElem>
  );
};

const DoubleContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${Spacing(2)};
`;

const SaveContainer = styled.div`
  display: grid;
  grid-template-columns: 5fr 1fr;
  grid-gap: ${Spacing(2)};
`;

const ExpandContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing(3)};
`;

const Container = styled.div`
  display: grid;
  width: 100%;
  grid-gap: ${Spacing(3)};
`;
